var c = Object.defineProperty;
var A = (e, E, s) => E in e ? c(e, E, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[E] = s;
var _ = (e, E, s) => A(e, typeof E != "symbol" ? E + "" : E, s);
var T = /* @__PURE__ */ ((e) => (e.SUCCESS = "SUCCESS", e.FAILURE = "FAILURE", e))(T || {}), O = /* @__PURE__ */ ((e) => (e.INVALID = "INVALID", e.NOT_FOUND = "NOT_FOUND", e.NOT_ALLOWED = "NOT_ALLOWED", e.NOT_AVAILABLE = "NOT_AVAILABLE", e.TEMPORARILY_NOT_AVAILABLE = "TEMPORARILY_NOT_AVAILABLE", e.CANCELED = "CANCELED", e.FAILED = "FAILED", e.API_NOT_FOUND = "API_NOT_FOUND", e))(O || {}), C = /* @__PURE__ */ ((e) => (e.INLINE = "inline", e.MAIN = "main", e.OVERLAY = "overlay", e.STATIC = "static", e))(C || {}), r = /* @__PURE__ */ ((e) => (e.KOOLEH = "KOOLEH", e.JARYAN = "JARYAN", e.MAVAKEB = "MAVAKEB", e.RAHKAR = "RAHKAR", e))(r || {}), I = /* @__PURE__ */ ((e) => (e.EDIT = "EDIT", e.SHARE = "SHARE", e.DELETE = "DELETE", e))(I || {});
const o = (e) => (E, s) => ({
  type: e,
  payload: E,
  meta: s
}), t = (e) => (E, s) => ({
  type: e,
  payload: E,
  meta: s
}), n = () => (e, E, s = T.SUCCESS) => ({
  payload: e,
  meta: E,
  status: s
}), N = "OPEN_LINK", Jt = n(), bt = t(N), S = "OPEN_IDENTIFIER", wt = n(), Xt = t(S), L = "OPEN_IMAGE", Qt = n(), jt = t(L), P = "OPEN_VIDEO", zt = n(), Zt = t(P), R = "SHARE", $t = n(), xt = t(R), a = "SET_CUSTOM_ACTIONS", te = n(), ee = t(a), i = "OPEN_LOCATION_PICKER", ne = n(), Ee = t(i), D = "GET_APP_CONFIG", oe = n(), se = t(D), l = "ACHIEVE_WAKE_LOCK", _e = t(l), G = "RELEASE_WAKE_LOCK", Te = t(G), U = "SET_NATIVE_COLORS", ce = n(), Ae = t(U), q = "CALL_RUNNING_OUT_OF_FOCUS", Oe = t(q), H = "SHOW_PERMISSION_BLOCKED_DIALOG", Ce = n(), re = t(H), W = "TOGGLE_FULLSCREEN", Ie = n(), Ne = t(W), p = "OPEN_SUPPORT", Se = t(p), M = "SHOW_PAYMENT_REQUIRED_DIALOG", Le = n(), Pe = t(M);
var d = /* @__PURE__ */ ((e) => (e.COPY_LINK = "COPY_LINK", e.INTERNAL_SHARE = "INTERNAL_SHARE", e.EXTERNAL_SHARE = "EXTERNAL_SHARE", e))(d || {}), Y = /* @__PURE__ */ ((e) => (e.MIC = "mic", e.CAMERA = "camera", e.CONTACTS = "contacts", e.NOTIFICATION = "notification", e))(Y || {});
const K = "GET_USERS", Re = n(), ae = t(K), B = "OPEN_USER_PROFILE", ie = n(), De = t(
  B
), F = "SET_MUTED", le = n(), Ge = t(F), V = "END_CALL", Ue = n(), qe = t(V), u = "EDIT_CALL_NAME", He = n(), We = t(u), k = "SHOW_NPS", pe = n(), Me = t(k), h = "GET_JOIN_ROOM_CREDENTIALS", de = n(), Ye = t(h), v = "CONNECT_WAPP", Ke = n(), Be = t(v), m = "START_WAPP", Fe = n(), Ve = t(m), y = "GET_WAPP_INPUT", ue = n(), ke = t(y), g = "GET_WAPP_CHILD_OUTPUT", he = n(), ve = t(
  g
), f = "CLOSE_WAPP", me = n(), ye = t(f), J = "HISTORY_PUSH", ge = t(J), b = "HISTORY_POP", fe = t(b), w = "HISTORY_REPLACE", Je = t(
  w
), X = "GET_WAPP_HISTORY", be = t(
  X
), Q = "GET_WAPP_HISTORY_TOP", we = t(
  Q
);
var j = /* @__PURE__ */ ((e) => (e.PUSH = "PUSH", e.POP = "POP", e.REPLACE = "REPLACE", e))(j || {});
const z = "GET_CHANNEL", Xe = n(), Qe = t(z), Z = "GET_ADMIN_CHANNELS", je = n(), ze = t(Z), $ = "OPEN_CHANNEL_PROFILE", Ze = n(), $e = t($), x = "JOIN_CHANNEL", xe = n(), tn = t(x), tt = "OPEN_CHANNEL_ROOM", en = n(), nn = t(tt), et = "GET_CLIENT_USER_AUTH_TOKEN", En = n(), on = t(et), nt = "GET_CLIENT_USER", sn = n(), _n = t(
  nt
), Et = "GET_CLIENT_USER_PROFILE", Tn = n(), cn = t(
  Et
), ot = "EDIT_CLIENT_USER_PROFILE", An = n(), On = t(ot), st = "IS_CLIENT_USER_CONTENT_OWNER", Cn = n(), rn = t(st), _t = "GET_CONTENT_TOKEN", In = n(), Nn = t(
  _t
), Tt = "INSTANTIATE_WAPP", Sn = t(Tt), ct = "OPEN_WAPP", Ln = n(), Pn = t(ct), At = "OPEN_STATIC_WAPP_BY_NAME", Rn = n(), an = t(
  At
), Ot = "REFRESH_CONTENT_SESSIONS", Dn = n(), ln = t(Ot), Ct = "WAPP_ACTIVITY_SEARCH", Gn = t(
  Ct
), rt = "WAPP_ACTIVITY_CREATE_ENTITY", Un = t(rt), It = "WAPP_ACTIVITY_EDIT_ENTITY", qn = t(It), Nt = "WAPP_ACTIVITY_POST", Hn = t(
  Nt
), St = "WAPP_ACTIVITY_DELETE_ENTITY", Wn = t(St), Lt = "SEND_ANALYTICS", pn = n(), Mn = t(Lt), Pt = "HISTORY_CHANGED", dn = o(Pt), Rt = "CUSTOM_ACTION_CLICKED", Yn = o(Rt), at = "WAPP_VISIBILITY_CHANGED", Kn = o(at), it = "CALL_MUTED_CHANGED", Bn = o(it), Dt = "CALL_NAME_CHANGED", Fn = o(Dt), lt = "CALL_PARTICIPANTS_COUNT_READY", Vn = o(lt), Gt = "LEFT_CALL", un = o(Gt), Ut = "SUBSCRIPTION_EVENT", kn = o(Ut), qt = "SOCKET_CONNECTED", hn = o(qt), Ht = "SOCKET_DISCONNECTED", vn = o(Ht), Wt = "EXITED_FULLSCREEN", mn = o(Wt), pt = "SET_BOOKMARK_DATA", yn = n(), gn = t(pt), Mt = "SET_BOOKMARK", fn = n(), Jn = t(Mt), dt = "DELETE_BOOKMARKS", bn = n(), wn = t(dt), Yt = "DELETE_COLLECTION", Xn = n(), Qn = t(Yt), Kt = "EDIT_COLLECTION", jn = n(), zn = t(Kt), Bt = "CREATE_COLLECTION", Zn = n(), $n = t(Bt), Ft = "GET_COLLECTIONS", xn = n(), tE = t(Ft), Vt = "GET_BOOKMARKS", eE = n(), nE = t(Vt);
class EE {
  constructor() {
    _(this, "contentUri");
    _(this, "markedAt");
  }
}
class oE {
  constructor() {
    _(this, "title");
    _(this, "cover");
    _(this, "createdAt");
    _(this, "markCount");
  }
}
const ut = "SUBSCRIBE_TO_TOPIC", sE = n(), _E = t(ut), kt = "GET_SHARED_MEDIA", TE = t(kt), cE = n(), ht = "GET_MESSAGES_BY_IID", AE = t(ht), OE = n(), vt = "GO_TO_MESSAGE_BY_IID", CE = t(vt), rE = n(), mt = "GET_OPENED_ROOM_ID", IE = t(mt), NE = n(), yt = "IS_VOD_ACTIVATED", SE = n(), LE = t(yt), gt = "PROFILER_DATA_AVAILABLE", PE = n(), RE = t(gt);
export {
  l as ACHIEVE_WAKE_LOCK,
  Y as BlockedPermissionType,
  it as CALL_MUTED_CHANGED,
  Dt as CALL_NAME_CHANGED,
  lt as CALL_PARTICIPANTS_COUNT_READY,
  q as CALL_RUNNING_OUT_OF_FOCUS,
  f as CLOSE_WAPP,
  v as CONNECT_WAPP,
  Bt as CREATE_COLLECTION,
  Rt as CUSTOM_ACTION_CLICKED,
  oE as Collection,
  I as CustomAction,
  dt as DELETE_BOOKMARKS,
  Yt as DELETE_COLLECTION,
  u as EDIT_CALL_NAME,
  ot as EDIT_CLIENT_USER_PROFILE,
  Kt as EDIT_COLLECTION,
  V as END_CALL,
  Wt as EXITED_FULLSCREEN,
  O as Exceptions,
  Z as GET_ADMIN_CHANNELS,
  D as GET_APP_CONFIG,
  Vt as GET_BOOKMARKS,
  z as GET_CHANNEL,
  nt as GET_CLIENT_USER,
  et as GET_CLIENT_USER_AUTH_TOKEN,
  Et as GET_CLIENT_USER_PROFILE,
  Ft as GET_COLLECTIONS,
  _t as GET_CONTENT_TOKEN,
  h as GET_JOIN_ROOM_CREDENTIALS,
  ht as GET_MESSAGES_BY_IID,
  mt as GET_OPENED_ROOM_ID,
  kt as GET_SHARED_MEDIA,
  K as GET_USERS,
  g as GET_WAPP_CHILD_OUTPUT,
  X as GET_WAPP_HISTORY,
  Q as GET_WAPP_HISTORY_TOP,
  y as GET_WAPP_INPUT,
  vt as GO_TO_MESSAGE_BY_IID,
  Pt as HISTORY_CHANGED,
  b as HISTORY_POP,
  J as HISTORY_PUSH,
  w as HISTORY_REPLACE,
  j as HistoryEvent,
  Tt as INSTANTIATE_WAPP,
  st as IS_CLIENT_USER_CONTENT_OWNER,
  yt as IS_VOD_ACTIVATED,
  x as JOIN_CHANNEL,
  Gt as LEFT_CALL,
  EE as Mark,
  $ as OPEN_CHANNEL_PROFILE,
  tt as OPEN_CHANNEL_ROOM,
  S as OPEN_IDENTIFIER,
  L as OPEN_IMAGE,
  N as OPEN_LINK,
  i as OPEN_LOCATION_PICKER,
  At as OPEN_STATIC_WAPP_BY_NAME,
  p as OPEN_SUPPORT,
  B as OPEN_USER_PROFILE,
  P as OPEN_VIDEO,
  ct as OPEN_WAPP,
  gt as PROFILER_DATA_AVAILABLE,
  Ot as REFRESH_CONTENT_SESSIONS,
  G as RELEASE_WAKE_LOCK,
  T as ResponseStatus,
  Lt as SEND_ANALYTICS,
  Mt as SET_BOOKMARK,
  pt as SET_BOOKMARK_DATA,
  a as SET_CUSTOM_ACTIONS,
  F as SET_MUTED,
  U as SET_NATIVE_COLORS,
  R as SHARE,
  k as SHOW_NPS,
  M as SHOW_PAYMENT_REQUIRED_DIALOG,
  H as SHOW_PERMISSION_BLOCKED_DIALOG,
  qt as SOCKET_CONNECTED,
  Ht as SOCKET_DISCONNECTED,
  m as START_WAPP,
  ut as SUBSCRIBE_TO_TOPIC,
  Ut as SUBSCRIPTION_EVENT,
  d as ShareEvent,
  r as StaticWappName,
  W as TOGGLE_FULLSCREEN,
  rt as WAPP_ACTIVITY_CREATE_ENTITY,
  St as WAPP_ACTIVITY_DELETE_ENTITY,
  It as WAPP_ACTIVITY_EDIT_ENTITY,
  Nt as WAPP_ACTIVITY_POST,
  Ct as WAPP_ACTIVITY_SEARCH,
  at as WAPP_VISIBILITY_CHANGED,
  C as WappMode,
  Bn as eventCallMutedChanged,
  Fn as eventCallNameChanged,
  Vn as eventCallParticipantsCountReady,
  Yn as eventCustomActionClicked,
  mn as eventExitedFullscreen,
  o as eventFactory,
  dn as eventHistoryChanged,
  un as eventLeftCall,
  hn as eventSocketConnected,
  vn as eventSocketDisconnected,
  kn as eventSubscriptionEvent,
  Kn as eventWappVisibilityChanged,
  _e as reqAchieveWakeLock,
  Oe as reqCallRunningOutOfFocus,
  ye as reqCloseWapp,
  Be as reqConnectWapp,
  $n as reqCreateCollection,
  wn as reqDeleteBookmarks,
  Qn as reqDeleteCollection,
  We as reqEditCallName,
  On as reqEditClientUserProfile,
  zn as reqEditCollection,
  qe as reqEndCall,
  ze as reqGetAdminChannels,
  nE as reqGetBookmarks,
  Qe as reqGetChannel,
  _n as reqGetClientUser,
  on as reqGetClientUserAuthToken,
  cn as reqGetClientUserProfile,
  tE as reqGetCollections,
  se as reqGetConfig,
  Nn as reqGetContentToken,
  Ye as reqGetJoinRoomCredentials,
  AE as reqGetMessagesByIid,
  IE as reqGetOpenedRoomId,
  TE as reqGetSharedMedia,
  ae as reqGetUsers,
  ve as reqGetWappChildOutput,
  be as reqGetWappHistory,
  we as reqGetWappHistoryTop,
  ke as reqGetWappInput,
  CE as reqGoToMessageByIid,
  fe as reqHistoryPop,
  ge as reqHistoryPush,
  Je as reqHistoryReplace,
  Sn as reqInstantiateWapp,
  rn as reqIsClientUserContentOwner,
  LE as reqIsVodActivated,
  tn as reqJoinChannel,
  $e as reqOpenChannelProfile,
  nn as reqOpenChannelRoom,
  Xt as reqOpenIdentifier,
  jt as reqOpenImage,
  bt as reqOpenLink,
  Ee as reqOpenLocationPicker,
  an as reqOpenStaticWappByName,
  Se as reqOpenSupport,
  De as reqOpenUserProfile,
  Zt as reqOpenVideo,
  Pn as reqOpenWapp,
  RE as reqProfilerDataAvailable,
  ln as reqRefreshContentSessions,
  Te as reqReleaseWakeLock,
  Mn as reqSendAnalytics,
  Jn as reqSetBookmark,
  gn as reqSetBookmarkData,
  ee as reqSetCustomActions,
  Ge as reqSetMuted,
  Ae as reqSetNativeColors,
  xt as reqShare,
  Me as reqShowNps,
  Pe as reqShowPaymentRequiredDialog,
  re as reqShowPermissionBlockedDialog,
  Ve as reqStartWapp,
  _E as reqSubscribeToTopic,
  Ne as reqToggleFullscreen,
  Un as reqWappActivityCreateEntity,
  Wn as reqWappActivityDeleteEntity,
  qn as reqWappActivityEditEntity,
  Hn as reqWappActivityPost,
  Gn as reqWappActivitySearch,
  t as requestFactory,
  me as resCloseWapp,
  Ke as resConnectWapp,
  Zn as resCreateCollection,
  bn as resDeleteBookmarks,
  Xn as resDeleteCollection,
  He as resEditCallName,
  An as resEditClientUserProfile,
  jn as resEditCollection,
  Ue as resEndCall,
  je as resGetAdminChannels,
  eE as resGetBookmarks,
  Xe as resGetChannel,
  sn as resGetClientUser,
  En as resGetClientUserAuthToken,
  Tn as resGetClientUserProfile,
  xn as resGetCollections,
  oe as resGetConfig,
  In as resGetContentToken,
  de as resGetJoinRoomCredentials,
  OE as resGetMessagesByIid,
  NE as resGetOpenedRoomId,
  cE as resGetSharedMedia,
  Re as resGetUsers,
  he as resGetWappChildOutput,
  ue as resGetWappInput,
  rE as resGoToMessageByIid,
  Cn as resIsClientUserContentOwner,
  SE as resIsVodActivated,
  xe as resJoinChannel,
  Ze as resOpenChannelProfile,
  en as resOpenChannelRoom,
  wt as resOpenIdentifier,
  Qt as resOpenImage,
  Jt as resOpenLink,
  ne as resOpenLocationPicker,
  Rn as resOpenStaticWappByName,
  ie as resOpenUserProfile,
  zt as resOpenVideo,
  Ln as resOpenWapp,
  PE as resProfilerDataAvailable,
  Dn as resRefreshContentSessions,
  pn as resSendAnalytics,
  fn as resSetBookmark,
  yn as resSetBookmarkData,
  te as resSetCustomActions,
  le as resSetMuted,
  ce as resSetNativeColors,
  $t as resShare,
  pe as resShowNps,
  Le as resShowPaymentRequiredDialog,
  Ce as resShowPermissionBlockedDialog,
  Fe as resStartWapp,
  sE as resSubscribeToTopic,
  Ie as resToggleFullscreen,
  n as responseFactory
};
//# sourceMappingURL=protocol.js.map
